<div class="modal-header text-center" style="border-bottom: none">
  <h4>Are you sure?</h4>
</div>
<div class="modal-body">
  <p>
    You are about to stop the time tracking for the job
    <strong>{{ jobName }}</strong
    >.<br />
    If you want to proceed, click stop.
  </p>
</div>
<div class="modal-footer">
  <div class="btn btn-default pull-left" aria-label="Cancel" (click)="cancel()">
    Cancel
  </div>
  <div
    class="btn btn-danger pull-right"
    aria-label="Confirm"
    (click)="confirm()"
  >
    Stop
  </div>
</div>
